<span *ngIf="status == 'success'" class="success trx-status">
  Payout Completed
</span>
<span *ngIf="status == 'pending'" class="pending trx-status"> Pending Payout </span>
<span *ngIf="status == 'failed'" class="failed trx-status"> Failed </span>
